module.exports = __webpack_public_path__ + "img/ad2.2dc55ce2.png";